import {createSelector} from 'reselect';

import {Controller} from '@stubhub/react-store-provider';

import {searchEvents} from '../../../utils/api';

const NAMESPACE = 'EVENT_SEO_LIST';
const eventsSelector = createSelector(
  (state) => state[NAMESPACE],
  (eventSEOList) => (eventSEOList ? eventSEOList.events : []),
);

const loadEvents = (props) => {
  return (dispatch, getState) => {
    let {searchParams} = props;
    const query = {
      status: 'active |contingent',
      sort: 'eventDateLocal asc',
      start: 0,
      rows: 40,
      needSEOMeta: true,
    };

    searchParams = {...searchParams, ...query};

    const {gsConfig} = getState() /* istanbul ignore next */ || {};
    searchParams.shstore = gsConfig.shstoreId;

    return searchEvents(searchParams, gsConfig).then((body) => {
      dispatch({
        type: 'EVENT_SEO_LIST_LOADED',
        events: body.events,
      });

      return null;
    });
  };
};

const resetEvents = () => {
  return (dispatch) => {
    dispatch({type: 'EVENT_SEO_LIST_RESET', events: []});
  };
};

const controller = new Controller({
  namespace: NAMESPACE,
  mapStateToProps(state) {
    const gsConfig = state.gsConfig /* istanbul ignore next */ || {};
    const supportedCountries = gsConfig.supportedCountries /* istanbul ignore next */ || [];
    const defaultWebTLD = gsConfig.defaultWebTLD /* istanbul ignore next */ || '';

    return {
      events: eventsSelector(state),
      localCountry: supportedCountries[0] /* istanbul ignore next */ || '',
      defaultWebTLD,
    };
  },
  actionCreators: {
    loadEvents,
    resetEvents,
  },
  reducers: ['EVENT_SEO_LIST_LOADED', 'EVENT_SEO_LIST_RESET'],
});

export default controller;
